import { get } from 'lodash';
import {
    ConvertVideo,
    PrepareLiveArchive,
    CropLiveArchive,
    LiveArchiveExpiration,
} from './graphql/stream-converter.graphql';

/**
 * @param {String} provider
 * @param {Number} assetId
 * @returns {Promise<Object>}
 */
export async function prepareConversionURL(provider, assetId) {
    const response = await this.query(ConvertVideo, {
        provider,
        assetId,
    });
    return get(response, 'convertVideo', {});
}

/**
 * @param {String} provider
 * @param {Number} assetId
 * @param {Object} [cutRange]
 * @param {Number} [cutRange.begin]
 * @param {Number} [cutRange.end]
 * @returns {Promise<Object>}
 */
export async function prepareLiveArchiveConversionURL(provider, assetId, cutRange) {
    const response = await this.query(PrepareLiveArchive, {
        provider,
        assetId,
        cutRange,
    });

    return get(response, 'prepareLiveArchive', {});
}

/**
 * @param {Object} params
 * @param {String} params.provider
 * @param {Number} params.assetId
 * @param {Object} params.cutRange
 * @param {Number} [params.cutRange.begin]
 * @param {Number} [params.cutRange.end]
 * @param {String} [params.editedBy]
 * @returns {Promise<Object>}
 */
export async function createCropFromLiveArchive({ provider, assetId, cutRange, editedBy }) {
    const response = await this.query(CropLiveArchive, {
        provider,
        assetId,
        cutRange,
        editedBy,
    });
    return get(response, 'cropLiveArchive', {});
}

/**
 * @param {String} provider
 * @param {Number} assetId
 * @returns {Promise<Number | null>}
 */
export async function liveArchiveExpiration(provider, assetId) {
    const response = await this.query(LiveArchiveExpiration, {
        provider,
        assetId,
    });
    return get(response, 'liveArchiveExpiration', null);
}
